import React, { useRef, useEffect, useState }  from 'react';
import { Box, Flex, useDisclosure, useBreakpointValue } from '@chakra-ui/react';
import SidebarComp from '../sidebar/Sidebar'; 
import MobileHeader from '../defaultHeader/MobileHeader';
import { useLocation } from 'react-router-dom';
import { sideBarMenu } from '../sidebar/utils/SidebarMenu';
import colors from '../../utils/colors';

interface Props {
    children: React.ReactNode; 
}

const Layout = ({ children }: Props) => {
    const { isOpen: isDrawerOpen, onOpen: onDrawerOpen, onClose: onDrawerClose } = useDisclosure();
    const drawerBtnRef = useRef<HTMLButtonElement>(null);
    const location = useLocation(); 
    const [currentPageTitle, setCurrentPageTitle] = useState<string | undefined>("Menu");
    const [hasMounted, setHasMounted] = useState(false);

    const mobileHeaderHeight = "60px"; 
    const isMobile = useBreakpointValue({ base: true, lg: false });

    useEffect(() => {
        setHasMounted(true);
    }, []);

    useEffect(() => {
        const activeMenuItem = sideBarMenu.find(item => {
            if (item.path === '/') return location.pathname === '/';
            const itemPath = item.path.endsWith('/') ? item.path.slice(0, -1) : item.path;
            const currentPathForMatch = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;
            return currentPathForMatch.startsWith(itemPath) && (currentPathForMatch.length === itemPath.length || currentPathForMatch[itemPath.length] === '/');
        });
        
        if (activeMenuItem) {
            setCurrentPageTitle(activeMenuItem.title);
        } else {
            if (location.pathname.startsWith('/profile')) {
                setCurrentPageTitle("Profile");
            } else if (location.pathname.match(/^\/patients\/[^/]+$/)) {
                setCurrentPageTitle("Patient Details");
            } else if (location.pathname.startsWith('/patients')) {
                setCurrentPageTitle("Patients");
            } else {
                setCurrentPageTitle(undefined); 
            }
        }
    }, [location.pathname]);

    const showMobileHeader = hasMounted && isMobile;
    const mainContentMarginTop = hasMounted && isMobile ? mobileHeaderHeight : "0";

    return (
        <Flex direction="column" h="100vh" maxH="100vh" bg={colors.lightGrey}>
            {showMobileHeader && (
                <MobileHeader 
                    onOpenDrawer={onDrawerOpen}
                    onCloseDrawer={onDrawerClose}
                    isDrawerOpen={isDrawerOpen}
                    drawerBtnRef={drawerBtnRef}
                    pageTitle={currentPageTitle}
                />
            )}
            <Flex 
                flex={1} 
                mt={mainContentMarginTop} 
                overflow="hidden" 
            > 
                <SidebarComp 
                    isDrawerOpen={isDrawerOpen} 
                    onDrawerClose={onDrawerClose} 
                    drawerBtnRef={drawerBtnRef} 
                />
                
                <Box
                    as="main"
                    flex={1} 
                    h="100%" 
                    overflowY="auto" 
                    overflowX="hidden"
                    p={{ base: "15px", md: "20px", lg: "24px" }}
                    id="main-content-area"
                >
                    {children}
                </Box>
            </Flex>
        </Flex>
    );
}

export default Layout;